import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fieldSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.field-selector-placeholder',
		defaultMessage: 'Select a field to map',
		description: 'Placeholder for field selector',
	},
	newField: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-field',
		defaultMessage: 'New field',
		description: 'Placeholder for field selector',
	},
	doNotImport: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.do-not-import',
		defaultMessage: 'Do not import',
		description: 'Button text for disabled state',
	},
	dateFormatError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.date-format-error',
		defaultMessage: 'Invalid date format',
		description: 'Date field formatting error',
	},
	dateTimeFormatError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.date-time-format-error',
		defaultMessage: 'Invalid date time format',
		description: 'Date time field formatting error',
	},
	numericalFormatError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.numerical-format-error',
		defaultMessage: 'Invalid field format. The field only supports numerical characters.',
		description: 'Numerical formatting error',
	},
	issueIdFormatError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.issue-id-format-error',
		defaultMessage:
			'Invalid field format. The field only supports alphanumeric characters and hyphens.',
		description: 'Issue id format error',
	},
	cascadingFormatError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.cascading-format-error',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Invalid field format. The field only supports the format parentValue -> childValue.',
		description: 'Cascading format error',
	},
	worklogFormatError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.worklog-format-error',
		defaultMessage:
			'Invalid work log format. <link>Read about the formats supported in this field.</link>',
		description: 'Work log format error',
	},
	emptySummaryError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.empty-summary-error',
		defaultMessage: 'Missing summary content in CSV',
		description: 'Missing summary error',
	},
	genericError: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.generic-error',
		defaultMessage: 'Invalid field format',
		description: 'Invalid field format',
	},
});
